import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="transition-opacity"
export default class extends Controller {
  static values = {
    end: String,
  }

  declare endValue: string

  connect () {
    this.element.classList.remove('opacity-0')
    this.element.classList.add(`opacity-${this.endValue}`)
  }
}
